export enum headerEnum {
  MARKETING_HUB = 'Shop Admin',
  SOCTRIP = "Soctrip",
  TMTRAVEL = 'TMTravel'
}
